/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".material-icons[_ngcontent-%COMP%]{color:#646464}.page[_ngcontent-%COMP%]{display:flex;position:relative}.page[_ngcontent-%COMP%]:not(:last-child){margin-bottom:1rem}label[_ngcontent-%COMP%]{width:100%;position:relative}.removalIcon[_ngcontent-%COMP%]{width:40px;text-align:center}.link[_ngcontent-%COMP%]{cursor:pointer;color:#21d196;text-decoration:underline}.page-then-text[_ngcontent-%COMP%]{position:absolute;color:#21d196;line-height:2.375rem;left:-40px}"];
export { styles as styles };
